import { render, staticRenderFns } from "./course-card.vue?vue&type=template&id=b6c9ce2e&scoped=true"
import script from "./course-card.vue?vue&type=script&lang=js"
export * from "./course-card.vue?vue&type=script&lang=js"
import style0 from "./course-card.vue?vue&type=style&index=0&id=b6c9ce2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c9ce2e",
  null
  
)

export default component.exports